"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("typeorm");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const helper_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/helper.utils");
const look_up_service_1 = require("../../../../org-service/src/app/look-up/look-up.service");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils/masters-validation");
const meeting_repository_1 = require("./meeting.repository");
let MeetingService = class MeetingService {
    constructor(meetingRepository, dataSource, lookUpValidation, lookUpService, masterValidation) {
        this.meetingRepository = meetingRepository;
        this.dataSource = dataSource;
        this.lookUpValidation = lookUpValidation;
        this.lookUpService = lookUpService;
        this.masterValidation = masterValidation;
    }
    // Create a new meeting
    async createMeeting(meetingData, entityManager) {
        try {
            const createMeeting = async (manager) => {
                await this.lookUpValidation.validateDynamicLookupValues(meetingData, constants_1.LOOK_UP_DATA);
                await this.masterValidation.validateMasterIds(meetingData, constants_1.MASTER_DATA);
                const { tpaParticipants, insurerParticipants, companyParticipants, employeeParticipants, documents, ...meetingDetails } = meetingData;
                // DEFAULT_MEETING_STATUS
                const meetingStatus = await this.lookUpService.getLookUpsByKey(constants_1.DEFAULT_MEETING_STATUS);
                meetingDetails.meetingStatusLid =
                    meetingDetails.meetingStatusLid || meetingStatus[0].id;
                const meeting = await this.meetingRepository.createMeeting(meetingDetails, manager);
                // Handle participants if any are present
                if (tpaParticipants ||
                    insurerParticipants ||
                    companyParticipants ||
                    employeeParticipants) {
                    await this.meetingRepository.saveMeetingParticipants(meeting.id, {
                        tpaParticipants,
                        insurerParticipants,
                        companyParticipants,
                        employeeParticipants,
                    }, manager);
                }
                else {
                    throw new common_1.BadRequestException(messages_1.errorMessages.meetingParticipantsRequired);
                }
                if (documents && documents.length > 0) {
                    await this.meetingRepository.saveMeetingDocuments(meeting.id, documents, manager);
                }
                return { id: meeting.id };
            };
            if (entityManager) {
                return await createMeeting(entityManager); // Use the provided transaction
            }
            else {
                return await this.dataSource.transaction(createMeeting); // Start a new transaction
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    // Get meetings with pagination, search, and sorting
    async getMeetings(page, limit, search, sort, userId, searchBy) {
        try {
            const searchParams = (0, helper_utils_1.mapSearchParams)(search);
            const sortParams = (0, helper_utils_1.mapSortParams)(sort);
            const meetings = await this.meetingRepository.getMeetings(page, limit, searchParams, sortParams, userId, searchBy);
            return meetings;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error; // Re-throw NotFoundException to be handled by the controller
            }
            throw new Error(messages_1.errorMessages.meetingListRetrievalFailed);
        }
    }
    // Get a meeting by ID
    async getMeetingById(id) {
        try {
            const meeting = await this.meetingRepository.getMeetingById(id);
            if (!meeting) {
                throw new common_1.NotFoundException(messages_1.errorMessages.meetingNotFound);
            }
            return meeting;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    // Update a meeting by ID
    async updateMeeting(id, updateMeetingData, entityManager) {
        try {
            const updateMeeting = async (manager) => {
                await this.lookUpValidation.validateDynamicLookupValues(updateMeetingData, constants_1.LOOK_UP_DATA);
                await this.masterValidation.validateMasterIds(updateMeetingData, constants_1.MASTER_DATA);
                const { tpaParticipants, insurerParticipants, companyParticipants, employeeParticipants, documents, ...meetingDetails } = updateMeetingData;
                await this.meetingRepository.updateMeeting(id, meetingDetails, manager);
                if (tpaParticipants ||
                    insurerParticipants ||
                    companyParticipants ||
                    employeeParticipants) {
                    await this.meetingRepository.saveMeetingParticipants(id, {
                        tpaParticipants,
                        insurerParticipants,
                        companyParticipants,
                        employeeParticipants,
                    }, manager);
                }
                if (documents && documents.length > 0) {
                    await this.meetingRepository.saveMeetingDocuments(id, documents, manager);
                }
                return { id };
            };
            if (entityManager) {
                return await updateMeeting(entityManager); // Use the provided transaction
            }
            else {
                return await this.dataSource.transaction(updateMeeting); // Start a new transaction
            }
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    // Delete a meeting by ID
    async deleteMeetingById(id) {
        try {
            await this.meetingRepository.deleteMeetingById(id);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
    async getMeetingsByOpportunityAndActivity(opportunityActivityId) {
        try {
            return await this.meetingRepository.getMeetingsByOpportunityAndActivity(opportunityActivityId);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException)
                throw error;
            throw new common_1.BadRequestException(error.message);
        }
    }
};
exports.MeetingService = MeetingService;
exports.MeetingService = MeetingService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof meeting_repository_1.MeetingRepository !== "undefined" && meeting_repository_1.MeetingRepository) === "function" ? _a : Object, typeof (_b = typeof typeorm_1.DataSource !== "undefined" && typeorm_1.DataSource) === "function" ? _b : Object, typeof (_c = typeof lookup_validation_1.LookUpValidationService !== "undefined" && lookup_validation_1.LookUpValidationService) === "function" ? _c : Object, typeof (_d = typeof look_up_service_1.LookUpService !== "undefined" && look_up_service_1.LookUpService) === "function" ? _d : Object, typeof (_e = typeof masters_validation_1.MasterValidationService !== "undefined" && masters_validation_1.MasterValidationService) === "function" ? _e : Object])
], MeetingService);
